module.exports = __webpack_public_path__ + "static/media/bootstrap.87d99487.png";